import React, { createContext, useContext } from 'react';

export type DashboardPeriod = 'this-month' | 'last-month' | 'last-3m' | 'ytd';
export type DashboardScope = 'personal' | 'team' | 'company';

type DashboardContextValue = {
  period: DashboardPeriod;
  scope: DashboardScope;
  currencyLabel?: string;
};

const DashboardContext = createContext<DashboardContextValue | undefined>(undefined);

export const useDashboardContext = () => {
  const ctx = useContext(DashboardContext);
  if (!ctx) throw new Error('useDashboardContext must be used within DashboardProvider');
  return ctx;
};

export const DashboardProvider: React.FC<React.PropsWithChildren<DashboardContextValue>> = ({ children, ...value }) => {
  return <DashboardContext.Provider value={value}>{children}</DashboardContext.Provider>;
};
